var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "contain" },
    [
      !_vm.planDetailStatus && _vm.modeType === "1"
        ? _c("WorkOverview", {
            attrs: { modeType: _vm.modeType },
            on: {
              changeModeType: _vm.changeModeType,
              showPlanDetail: _vm.showPlanDetail,
            },
          })
        : !_vm.planDetailStatus && _vm.modeType === "2"
        ? _c("OverallDataOverview", {
            attrs: { modeType: _vm.modeType },
            on: { changeModeType: _vm.changeModeType },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }